import React from "react";
import { useSelector, useDispatch } from "react-redux";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/goalsSagas";

const FilterDropdown = ({
  filterKey,
  name,
  maxSelect,
  valueKey,
  labelKey,
  width = "150px",
  goalType,
  ...rest
}) => {
  const dispatch = useDispatch();
  const options = useSelector((state) => state.newGoals.addStaffModal.filters[filterKey]);
  const isFilterLoading = useSelector(
    (state) => state.newGoals.addStaffModal.isFiltersLoading[filterKey]
  );
  const selectedOptions = useSelector((state) => state.newGoals.addStaffModal.selectedFilters);
  const onSelectChange = (data) => {
    if (maxSelect && maxSelect === 1) {
      return dispatch(
        actionCreators.updateModalFilter({
          selectedFilter: { [filterKey]: data.slice(-1) },
          filterName: filterKey,
          goalType: goalType
        })
      );
    }

    dispatch(
      actionCreators.updateModalFilter({
        selectedFilter: { [filterKey]: data },
        filterName: filterKey,
        goalType: goalType
      })
    );
  };

  return (
    <div style={{ width }}>
      {name && <p>{name}</p>}
      {isFilterLoading ? (
        <LoadingAnimation uiLoader />
      ) : (
        <MultiSelectDropdown
          valueKey={valueKey}
          labelKey={labelKey}
          options={options}
          selectedFilters={selectedOptions[filterKey]}
          numberDisplayed={0}
          maxSelect={maxSelect}
          enableMax
          height={220}
          enableDefaultSelected
          haveOnSelectChange={false}
          includeFilter={false}
          onSelectChange={onSelectChange}
          {...rest}
        />
      )}
    </div>
  );
};

export default FilterDropdown;
